import { render } from "./ProductDescription.vue?vue&type=template&id=3cdb3bd4&scoped=true"
import script from "./ProductDescription.vue?vue&type=script&lang=js"
export * from "./ProductDescription.vue?vue&type=script&lang=js"

import "./ProductDescription.vue?vue&type=style&index=0&id=3cdb3bd4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdb3bd4"]])

export default __exports__